export const IDENTITY_PDF_MODAL_OPEN = 'IDENTITY_PDF_MODAL_OPEN'
export const IDENTITY_PDF_MODAL_CLOSE = 'IDENTITY_PDF_MODAL_CLOSE'
export const IDENTITY_PDF_MODAL_RESET = 'IDENTITY_PDF_MODAL_RESET'

function open(content) {
  return {
    type: IDENTITY_PDF_MODAL_OPEN,
    content,
  }
}

function close() {
  return {
    type: IDENTITY_PDF_MODAL_CLOSE,
  }
}

function reset() {
  return {
    type: IDENTITY_PDF_MODAL_RESET,
  }
}

export function openIdentityPdfModalDialog(content) {
  return (dispatch) => {
    dispatch(open(content))
  }
}

export function closeIdentityPdfModalDialog() {
  return (dispatch) => {
    dispatch(close())
  }
}

export function resetIdentityPdfModalDialog() {
  return (dispatch) => {
    dispatch(reset())
  }
}
